/*
  COTANTIN — フォームの入力チェック（VID 適用 実装指示書 v1.16 §3.14）。
  form[data-ct-form] の送信時に、必須の空欄・メールアドレスの形式・未選択・同意を確かめ、
  該当する項目の枠を #C25000 にして下に 12px の文言を出す（ブラウザ標準の吹き出しは使わない）。
  文言はフォームの data-msg-* から読む（セクション設定で変えられる）。
  Shopify 側の入力チェック（メール形式）は送信後にも走るので、ここを外しても送信は壊れない。
*/
(function () {
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function fieldOf(el) {
    return el.closest('[data-ct-field]');
  }

  function setError(field, message) {
    if (!field) return;
    var error = field.querySelector('.ct-form__error');
    var controls = field.querySelectorAll('input, select, textarea');
    field.classList.toggle('is-error', !!message);
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
    controls.forEach(function (control) {
      if (message) {
        control.setAttribute('aria-invalid', 'true');
        if (error) control.setAttribute('aria-describedby', error.id);
      } else {
        control.removeAttribute('aria-invalid');
      }
    });
  }

  function messageFor(form, el) {
    var value = (el.value || '').trim();
    if (el.type === 'checkbox') {
      return el.required && !el.checked ? form.dataset.msgConsent : '';
    }
    if (el.type === 'radio') {
      if (!el.required) return '';
      var checked = form.querySelector('input[type="radio"][name="' + CSS.escape(el.name) + '"]:checked');
      return checked ? '' : form.dataset.msgChoice;
    }
    if (el.required && !value) {
      return el.tagName === 'SELECT' ? form.dataset.msgChoice : form.dataset.msgRequired;
    }
    if (el.type === 'email' && value && !EMAIL.test(value)) {
      return form.dataset.msgEmail;
    }
    return '';
  }

  function check(form, el) {
    var message = messageFor(form, el);
    setError(fieldOf(el), message);
    return !message;
  }

  function init(form) {
    if (form.__ctForm) return;
    form.__ctForm = true;
    form.setAttribute('novalidate', '');

    form.addEventListener('submit', function (event) {
      var first = null;
      var seen = {};
      form.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (el.type === 'hidden' || el.disabled || !fieldOf(el)) return;
        if (el.type === 'radio') {
          if (seen[el.name]) return;
          seen[el.name] = true;
        }
        if (!check(form, el) && !first) first = el;
      });
      if (first) {
        event.preventDefault();
        first.focus({ preventScroll: true });
        var field = fieldOf(first);
        if (field && field.scrollIntoView) field.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    // 直したら、その場でエラーを消す（打っている途中では出さない）
    ['input', 'change'].forEach(function (type) {
      form.addEventListener(type, function (event) {
        var field = fieldOf(event.target);
        if (field && field.classList.contains('is-error')) check(form, event.target);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('form[data-ct-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
